var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-div"},[_c('span',{staticClass:"logo-title-name"},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"logo-title-dot"},[_vm._v(_vm._s(_vm.dot))])])}
var staticRenderFns = []

export { render, staticRenderFns }